import { Box, Flex } from "@chakra-ui/react";
import { Cell } from "../Cell";
import { Row } from "../Row";
import { TrendHelpModal } from "../HelpModal";
import React from "react";
import { useBatchRenderedList } from "../../hooks/useBatchRenderedList";


const ghanaLotto = "Ghana Lotto"

export const Trend = ({dataList, summary, gameName}) => {

    console.log('Rendering Trend')
    const borderStyle = "1px solid black"
    const DemarcationStyle = "2px dashed #878282"
    const DemarcationPosition = 30

    const ReversedDataList = [...dataList].reverse()
    const batchList = useBatchRenderedList(ReversedDataList)

    return (  
        <>
        <TrendHelpModal width="90%"/>

        <Box
            id="result_trend"
            overflow="auto"
            width="100%"
            height="77vh"
        >  

            <Box as="table">
                <Box as="thead" position="sticky" top="0" zIndex="2" bg="white"
                    boxShadow = "0px 1px 5px #454444"
                >
                    <Row>
                        <DateCell gameName={gameName} >Draw Time</DateCell>
                        {gameName === 'Ghana Lotto' && <GameCell justify="center">Game</GameCell>}     
                        <ResultCell>Results</ResultCell>
                        {Array.from({length: 90}, (_, index) => {
                            let slotNumber = index + 1
                            return (
                                <NumberCell 
                                    key={slotNumber} 
                                    borderRight={parseInt(slotNumber) % DemarcationPosition === 0 && slotNumber !== 90 ? DemarcationStyle : borderStyle}
                                >
                                    {slotNumber.toString().padStart(2, "0")}
                                </NumberCell>
                            )
                        })}
                    </Row> 
                </Box>

                <Box as="tbody" className="data">
                    {batchList.map((data) => {
                        const results = data.results.map((result) => parseInt(result)).sort((a, b) => a - b)
                        return (
                            <Row key={data.issue_no}>
                                <DateCell date={data.end_time} gameName={gameName}/>
                                {gameName === 'Ghana Lotto' && <GameCell>{data.sub_name}</GameCell>}   
                                <ResultCell results={results}/>

                                {Array.from({"length": 90}, (_, index) => {
                                    let slotNumber = index + 1
                                    let slotNumber2DigitStr = slotNumber.toString().padStart(2, '0')
                                    let content;
                                    if (data.results.includes(slotNumber2DigitStr)){
                                        content = <HighlightedNumber> {slotNumber2DigitStr}</HighlightedNumber>
                                     } else {
                                         content = data.omissions[slotNumber2DigitStr]
                                     }

                                    return (                                        
                                        <NumberCell key={`${data.issue_no}-${slotNumber}`} borderRight={parseInt(slotNumber) % DemarcationPosition === 0 && slotNumber !== 90 ? DemarcationStyle : borderStyle}>
                                            {content}
                                        </NumberCell>
                                    ) 
                                })}


                            </Row> 
                        )
                    })}
                </Box>

                <Box as="tbody" height="5px"/>

                <Box as="tbody" className="summary">
                    {Object.entries(summary).map((entry, summaryIndex) => {
                        const [summaryName, sumaryValue] = entry
                        return (
                            <Row key={summaryIndex}>
                                <DateCell gameName={gameName}>{summaryName.replace("Successive", "")}</DateCell>
                                {gameName === ghanaLotto && <GameCell></GameCell>}
                                <ResultCell></ResultCell>

                                {Array.from({"length": 90}, (_, index) => {
                                    let slotNumber = index + 1
                                    let slotNumber2DigitStr = slotNumber.toString().padStart(2, '0')

                                    return (                                        
                                        <NumberCell key={index} borderRight={parseInt(slotNumber) % DemarcationPosition === 0 && slotNumber !== 90 ? DemarcationStyle : borderStyle}>
                                            {sumaryValue[slotNumber2DigitStr]}
                                        </NumberCell>
                                    ) 
                                })}
                            </Row> 
                        )
                    })}
                </Box>
            </Box>
        </Box>
        </>
    )
}



export const DateCell = ({children, date, gameName, ...props}) => {
    return (
        <Cell
            className="date_cell"
            width={gameName === ghanaLotto ? {base: "80px", md:"95px"} : {base: "130px", md:"150px"}}
            position="sticky" 
            left="0"
            zIndex="1"
            bg = "inherit"
            boxShadow = "1px 0px 5px #454444"
            justify="center"
            {...props}
        >
            {children}
            {/* {date && date.split(" ")[0].replaceAll("/", "-")} */}
            {gameName === ghanaLotto ? date && date.split(" ")[0].replace(/\//g, "-") : date && date.split(/:00$/)[0].replace(/\//g, "-")}
        </Cell>  
    )
}


export const ResultCell = ({children, results, ...props}) => {
    return (
        <Cell
            className="result_cell"
            width="125px"
            justify="center"
            {...props}
        >
            {children}
            {results && results.map((result, index) => <Box key={index} as="span" width="25px" textAlign="center">{result.toString().padStart(2, '0')}</Box>)}
        </Cell>  
    )
}

export const GameCell = ({children, ...props}) => {
    return (
        <Cell
            className="game_cell"
            width={{base:"145px", md: "175px"}}
            paddingLeft="5px"
            {...props}
        >
            {children}
        </Cell>  
    )
}

const NumberCell = ({children, slotNumber, ...props}) => {
    return (
        <Cell
            className="number_cell"
            justify="center"
            align="center"
            width="30px"
            height="30px"
            {...props}
        >
            {children}
        </Cell>  
    )
}

const HighlightedNumber = ({children, ...props}) => {
    return (
        <Flex
            className="highlighted_number"
            justify="center"
            align="center"
            width="90%"
            height="90%"
            borderRadius="50%"
            padding="3px"
            backgroundImage = "linear-gradient(45deg, lightgreen, black)"
            color="white"
            {...props}
        >
            {children}
        </Flex>  
    )
}





